import packageJson from "../../../package.json";
import "./Footer.scss";

const version = process.env.REACT_APP_VERSION;
function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="footer">
        <p className="copyright-label text-center">
          ©{currentYear} Synoverge Technologies Pvt. Ltd. All Rights Reserved. Version: {packageJson.version}
        </p>
      </div>
    </>
  );
}

export default Footer;
